/* eslint-disable no-irregular-whitespace */
import React from 'react';
import { useSelector } from 'react-redux';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';

export const useTitle = () => {
    return 'Загружать, смотреть файлы и делиться ими скоро будет нельзя';
};

export const useContent = () => {
    const { used, userTotalSpace } = useSelector(UserQuotaSelectors.getUserQuotaState);

    return (
        <>
            В едином пространстве Почты и Облака <span>{used?.space}</span> из <span>{userTotalSpace?.value}</span> — оно почти переполнено.
            <br />
            Увеличьте его с подпиской Mail Space
        </>
    );
};
